import { render, staticRenderFns } from "./BranceTax.vue?vue&type=template&id=1c5a83fa"
import script from "./BranceTax.vue?vue&type=script&lang=js"
export * from "./BranceTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports